import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { TextButton, Typography } from 'seagull';
import s from './TriageFieldBox.module.scss';
export const TriageFieldBox = (param)=>{
    let { variant, badges, actions, forceActionsVisible, className, testId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(s.box, className),
        "data-testid": testId,
        children: [
            variant.type === 'text' && /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                ellipsis: true,
                testId: variant.testId,
                children: variant.value
            }),
            variant.type === 'editableText' && /*#__PURE__*/ _jsx("input", {
                "data-testid": variant.testId,
                className: s.editableText,
                value: variant.value,
                onChange: (e)=>variant.onChange(e.target.value)
            }),
            badges && /*#__PURE__*/ _jsx("div", {
                className: s.badges,
                children: badges
            }),
            actions != null && actions.length > 0 && /*#__PURE__*/ _jsx("div", {
                className: cn(s.actions, {
                    [s.actionsVisible]: forceActionsVisible
                }),
                children: actions.map((action)=>/*#__PURE__*/ _jsx(TextButton, {
                        underline: "none",
                        variant: "paragraph2",
                        weight: "normal",
                        testId: action.testId,
                        onClick: action.onClick,
                        children: action.text
                    }, action.testId))
            })
        ]
    });
};
